var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.customerId)?_c('router-link',{staticClass:"btn btn-info",attrs:{"to":{
            name: _vm.routeBase + '.customers.show',
            params: { id: _vm.customerId },
        },"target":"_blank"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" View customer\n    ")]):_vm._e(),_vm._v(" "),(_vm.isOffice && _vm.customerId && _vm.siteId)?_c('router-link',{staticClass:"btn btn-info",attrs:{"to":{
            name: 'office.sites.edit',
            params: { customer_id: _vm.customerId, id: _vm.siteId },
        },"target":"_blank"}},[_c('i',{staticClass:"fa fa-map-marker-alt"}),_vm._v(" View site\n    ")]):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc303ac6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/parts/CustomerSiteFooterLinks.vue
// module id = +MNd
// module chunks = 0